<template>
  <div class="min-w-[130px]">
    <label
      v-if="label"
      for="quantity-input"
      class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
      >{{ label }}</label
    >
    <div class="relative flex items-center max-w-[8rem]">
      <button
        type="button"
        class="bg-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:border-gray-600 hover:bg-gray-200 border border-gray-300 rounded-s-lg p-3 h-10 focus:ring-gray-100 dark:focus:ring-gray-700 focus:ring-2 focus:outline-none"
        @click="decrement"
      >
        <MinusIcon class="w-3" />
      </button>
      <input
        id="quantity-input"
        :value="displayValue"
        type="text"
        aria-describedby="helper-text-explanation"
        :class="[
          'bg-gray-50 px-1 border-x-0 border-y !border-gray-300 h-10 text-center text-gray-900 text-sm focus:ring-blue-500 focus:border-blue-500 block w-full py-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500',
          { ' pb-6': subLabel }
        ]"
        :max="max"
        :min="min"
        disabled
        @input="handleInput"
      />
      <div
        v-if="subLabel"
        class="absolute bottom-1 start-1/2 -translate-x-1/2 rtl:translate-x-1/2 flex items-center text-xs text-gray-400 space-x-1 rtl:space-x-reverse"
      >
        <span>{{ subLabel }}</span>
      </div>
      <button
        type="button"
        class="bg-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:border-gray-600 hover:bg-gray-200 border border-gray-300 rounded-e-lg p-3 h-10 focus:ring-gray-100 dark:focus:ring-gray-700 focus:ring-2 focus:outline-none"
        @click="increment"
      >
        <PlusIcon class="w-3" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import MinusIcon from "@/images/minus-outline.svg?component";
import PlusIcon from "@/images/plus-outline.svg?component";

const emit = defineEmits(["update:modelValue"]);
const props = withDefaults(
  defineProps<{
    label?: string;
    subLabel?: string;
    modelValue: number;
    min?: number;
    max?: number;
    step?: number;
    percent?: boolean;
  }>(),
  {
    step: 1
  }
);

const inputVal = computed({
  get() {
    return props.modelValue;
  },
  set(val) {
    emit("update:modelValue", val);
  }
});
const displayValue = computed(
  () => props.modelValue + `${props.percent ? "%" : ""}`
);
const handleInput = (val) => (inputVal.value = val);
const increment = () =>
  (inputVal.value = props.max
    ? Math.min(props.max, props.modelValue + props.step)
    : props.modelValue + props.step);
const decrement = () =>
  (inputVal.value = props.min
    ? Math.max(props.min, props.modelValue - props.step)
    : props.modelValue - props.step);
</script>
